<template>
  <BaseCard
    no-padding
    class="tw:absolute tw:z-10 tw:flex tw:top-[65px] tw:font-normal tw:text-gray-800 tw:cursor-auto tw:w-[200px]"
  >
    <div class="tw:flex tw:w-full tw:p-3">
      <ul class="tw:w-full">
        <li
          v-for="item in props.links"
          :key="item.id"
          class="tw:w-[100%] tw:flex tw:rounded-md tw:hover:font-bold"
          @mouseover="selectElement(item.id)"
          :data-testid="`${item.dataTestId}`"
        >
          <a
            class="tw:hover:no-underline tw:w-full tw:py-2 tw:px-2 tw:hover:text-gray-800 tw:flex tw:items-center tw:justify-between tw:hover:bg-gray-200 tw:hover:rounded"
            :href="item.isUrl ? item.url : getSalesforceUrl(item.url)"
            :target="item.newPage ? '_blank' : ''"
          >
            <span v-html="$t(item.label)" />
            <External v-if="item.withIcon" />
          </a>
        </li>
      </ul>
    </div>
  </BaseCard>
</template>
<script setup>
import { ref, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import { useSessionValues } from '@/composables/useSessionValues'
import { getSupportCenterUrl, getContactUrl } from '@/utils/Utility.ts'

import BaseCard from '@/components/dashboard/BaseCard.vue'
import External from '@/components/icons/External.svg?component'

const route = useRoute()
const props = defineProps({
  links: Array,
  type: String,
})

const { language } = useSessionValues()
const selected = ref(0)

const getSalesforceUrl = type => {
  if (type === 'contactUs') {
    return getContactUrl(language.value)
  }
  if (type === 'supportCentre') {
    return getSupportCenterUrl(language.value)
  }
}

const selectElement = id => {
  selected.value = id
}

onMounted(() => {
  const path = '/home' + route.path
  const currentUrl = props.links.find(item => item.url === path)
  selectElement(currentUrl?.id || 0)
})
</script>
